import type { EpdPrecheckIssue } from '@app/models/orders';

export enum ErrorCode {
  BAD_INTAKE = 'bad_intake',
  NOT_UNIQUE = 'product_code_not_unique',

  USER_EMAIL_NOT_UNIQUE = 'user_email_not_unique',
  USER_USERNAME_NOT_UNIQUE = 'user_username_not_unique',
  USER_PHONE_NOT_UNIQUE = 'user_phone_not_unique',

  INVALID_INN = 'invalid_inn',
  PARTY_NOT_FOUND = 'party_not_found',
  PARTY_NOT_ACTIVE = 'party_not_active',
  PARTY_REGISTRY_UNAVAILABLE = 'party_registry_unavailable',
  SCOPE_LEGAL_ENTITY_NOT_UNIQUE = 'scope_legal_entity_not_unique',

  LEGAL_ENTITY_SANDBOX_FORBIDDEN = 'legal_entity_sandbox_forbidden',
  INVALID_EDO_PARTICIPANT_ID = 'invalid_edo_participant_id',
  EDO_PROFILE_UNAVAILABLE = 'edo_profile_unavailable',
  EPD_POA_UNAVAILABLE = 'epd_poa_unavailable',
  EPD_PRECHECK_FAILED = 'epd_precheck_failed',
  EPD_SIGNING_NOT_FOUND = 'epd_signing_not_found',
  EPD_SIGNING_BUSY = 'epd_signing_busy',
  EPD_SIGNING_JOB_HELD = 'epd_signing_job_held',
  EPD_SIGNING_UNAVAILABLE = 'epd_signing_unavailable',
  EPD_SIGNING_FORBIDDEN = 'epd_signing_forbidden',
  EPD_SIGNING_GROUNDS_INVALID = 'epd_signing_grounds_invalid',
  EPD_DATA_CHANGED = 'epd_data_changed',
  EPD_SIGNING_OPERATOR_UNAVAILABLE = 'epd_signing_operator_unavailable',
  EPD_SIGNING_PREPARATION_FAILED = 'epd_signing_preparation_failed',
  EPD_SIGNATURE_INVALID = 'epd_signature_invalid',
  EPD_POA_CHECK_FAILED = 'epd_poa_check_failed',
  EPD_SENDING_REFUSED = 'epd_sending_refused',
  EPD_TITLE_FILE_NOT_FOUND = 'epd_title_file_not_found',
  EPD_POA_NOT_FOUND = 'epd_poa_not_found',
  EPD_POA_LEGAL_ENTITY_NOT_FOUND = 'epd_poa_legal_entity_not_found',
  EPD_POA_PARTICIPATION_NOT_FOUND = 'epd_poa_participation_not_found',
  EPD_POA_DUPLICATE = 'epd_poa_duplicate',
  EPD_POA_REVOKED = 'epd_poa_revoked',
  EPD_POA_PERIOD_INVALID = 'epd_poa_period_invalid',
  PARTICIPATION_POA_MODULE_INVALID = 'participation_poa_module_invalid',

  PARTICIPATION_NOT_UNIQUE = 'participation_not_unique',
  PARTICIPATION_TRANSITION_FORBIDDEN = 'participation_transition_forbidden',
  COUNTERPARTY_INVITATION_NOT_ALLOWED = 'counterparty_invitation_not_allowed',
  COUNTERPARTY_INVITATION_EMAIL_TAKEN = 'counterparty_invitation_email_taken',
  COUNTERPARTY_INVITATION_NOT_LIVE = 'counterparty_invitation_not_live',
  COUNTERPARTY_INVITATION_ACCOUNT_MISSING = 'counterparty_invitation_account_missing',
  COUNTERPARTY_INVITATION_ADDRESSEE_DEACTIVATED = 'counterparty_invitation_addressee_deactivated',

  WAREHOUSE_TRANSITION_FORBIDDEN = 'warehouse_transition_forbidden',

  PARTICIPATION_HAS_UNFINISHED_ORDERS = 'participation_has_unfinished_orders',
  WAREHOUSE_HAS_UNFINISHED_ORDERS = 'warehouse_has_unfinished_orders',
  ORDER_SERVICE_UNAVAILABLE = 'order_service_unavailable',
  ADDRESS_NOT_FOUND = 'address_not_found',
  DICTIONARY_SERVICE_UNAVAILABLE = 'dictionary_service_unavailable',
  USER_SERVICE_UNAVAILABLE = 'user_service_unavailable',
  PERMISSION_RESTRICTION_VIOLATED = 'permission_restriction_violated',
}

export interface IErrorOrderRef {
  uid: string;
  num: number;
}

export interface IError {
  id: string;
  status?: number;
  code: ErrorCode;
  title: string;
  detail: string;
  source: {
    pointer: string;
  };
  meta: {
    field?: string;
    field_name?: string;
    cell?: string;
    variants: { attr?: string; attr_name?: string }[] | undefined;
    orders?: IErrorOrderRef[];
    issues?: EpdPrecheckIssue[];
    problems?: string[];
  };
}

export interface IErrorResponse {
  errors: IError[];
}
